import { Component, OnInit, ViewChild } from '@angular/core';
import { VariavelFormula } from 'src/app/models/variavel-formula';
import { MatPaginator, MatDialog, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { VariavelFormulaService } from 'src/app/services/variavel-formula.service';
import { FormulaVariavelModalComponent } from '../formula-variavel-modal/formula-variavel-modal.component';

declare const $: any;

@Component({
  selector: 'app-variavel-personalizada-modal',
  templateUrl: './variavel-personalizada-modal.component.html',
  styleUrls: ['./variavel-personalizada-modal.component.scss']
})
export class VariavelPersonalizadaModalComponent implements OnInit {
  variaveisFiltradas: VariavelFormula[] = [];
  carregando = true;
  ordenarDesc = false;
  editavel = true;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<VariavelPersonalizadaModalComponent>,
    private variavelFormulaService: VariavelFormulaService
  ) { }

  ngOnInit(): void {
    this.buscarVariaveis();
  }

  salvarVariavel(variavel: VariavelFormula) {
    this.carregandoService.mostra('salvarVariavel');

    this.variavelFormulaService.salvar(variavel).subscribe(
      () => {
        this.buscarVariaveis();
        this.carregandoService.esconde('salvarMaxPainel');
      },
      err => {
        this.carregandoService.esconde('salvarMaxPainel');
        this.notificacaoService.erro(err);

      }
    )
  }

  buscarVariaveis() {
    this.carregandoService.mostra('buscarVariaveis');

    this.variavelFormulaService.consultarLista().subscribe(
      (vars) => {
        this.variaveisFiltradas = vars;

        this.carregandoService.esconde('buscarVariaveis');
      }
      , err => {
        this.carregandoService.esconde('buscarVariaveis');
        this.notificacaoService.erro(err);
      }
    );
  }

  novaVariavel() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(FormulaVariavelModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card',
      data: {}
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;
      this.buscarVariaveis();
    });
  }

  editarVariavel(variavelPersonalizada: VariavelFormula) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(FormulaVariavelModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { variavelPersonalizada },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;
      this.buscarVariaveis();
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
